import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { WORKSHEET_CALCULATED_VALUES_TITLE } from '../../WorksheetDrawer.constants';
import {
  worksheetCalculatedValueRowStyles,
  worksheetCalculatedValuesWrapperStyles,
} from '../../WorksheetDrawer.styles';
import { formatWorksheetCalculatedValue } from '../../WorksheetDrawer.utils';

import { WorksheetCalculatedValuesPanelTestIds } from './WorksheetCalculatedValuesPanel.testIds';

/**
 * Read-only list of the worksheet document type's calculation fields, evaluated live against the
 * form. Renders nothing for worksheet types that have no calculation fields.
 */
const WorksheetCalculatedValuesPanel = ({ calculatedValues = [] }) => {
  if (!calculatedValues.length) {
    return null;
  }

  return (
    <Box
      data-testid={WorksheetCalculatedValuesPanelTestIds.PANEL}
      sx={worksheetCalculatedValuesWrapperStyles}
    >
      <Typography className="mb-12" component="div" variant="bold16">
        {WORKSHEET_CALCULATED_VALUES_TITLE}
      </Typography>

      {calculatedValues.map(({ calculationFieldId, name, description, value }) => (
        <Box
          data-testid={WorksheetCalculatedValuesPanelTestIds.ROW}
          key={calculationFieldId}
          sx={worksheetCalculatedValueRowStyles}
          title={description ?? undefined}
        >
          <Typography component="span" variant="regular14">
            {name}
          </Typography>
          <Typography
            component="span"
            data-testid={WorksheetCalculatedValuesPanelTestIds.VALUE}
            variant="bold14"
          >
            {formatWorksheetCalculatedValue(value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

WorksheetCalculatedValuesPanel.propTypes = {
  calculatedValues: PropTypes.arrayOf(
    PropTypes.shape({
      calculationFieldId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

export default memo(WorksheetCalculatedValuesPanel);
